import { z } from "zod";
import { ShortText, MediumText, FISHBONE_KNOWN_CATEGORIES, FishboneCategory, idString, } from "./common.js";
const FishboneCause = z
    .object({
    id: idString,
    text: MediumText,
})
    .strict();
const FishboneBranch = z
    .object({
    id: idString,
    category: FishboneCategory,
    causes: z.array(FishboneCause).max(50),
})
    .strict();
/**
 * Fishbone (Ishikawa) — Look, singleton. Effect at the trunk, branches
 * by category. The 6 canonical "Man / Method / Machine / Material /
 * Measurement / Environment" get fixed palette colors; arbitrary
 * additional categories cycle through a fallback palette.
 */
export const FishboneParamsSchema = z
    .object({
    effect: ShortText,
    branches: z.array(FishboneBranch).max(20),
})
    .strict();
export { FISHBONE_KNOWN_CATEGORIES };
export const defaultFishboneParams = {
    effect: "Effect",
    branches: FISHBONE_KNOWN_CATEGORIES.map((category, i) => ({
        id: `br-${i + 1}`,
        category,
        causes: [],
    })),
};
//# sourceMappingURL=fishbone.js.map